import { ListModel } from "../models/list-model";

export const formBonos: ListModel[] = [
  { value: "0", label: "No Posee" },
  { value: "E2", label: "E2" },
  { value: "E3", label: "E3" },
  { value: "E4", label: "E4" },
  { value: "E7", label: "E7" },
  { value: "MI", label: "MI" },
  { value: "MA", label: "MA" },
  { value: "MB", label: "MB" },
  { value: "MC", label: "MC" },
  { value: "MD", label: "MD" },
  { value: "PI", label: "PI" },
  { value: "1.01", label: "1.01" },
  { value: "1.02", label: "1.02" },
  { value: "1.03", label: "1.03" },
  { value: "1.04", label: "1.04" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "7.01", label: "7.01" },
  { value: "7.02", label: "7.02" },
  { value: "7.03", label: "7.03" },
  { value: "7.04", label: "7.04" },
  { value: "7.05", label: "7.05" },
  { value: "7.06", label: "7.06" },
  { value: "7.07", label: "7.07" },
  { value: "7.08", label: "7.08" },
  { value: "7.09", label: "7.09" },
  { value: "7.10", label: "7.10" },
  { value: "7.11", label: "7.11" },
  { value: "7.12", label: "7.12" },
  { value: "7.13", label: "7.13" },
  { value: "7.14", label: "7.14" },
  { value: "7.15", label: "7.15" },
  { value: "7.16", label: "7.16" },
  { value: "7.17", label: "7.17" },
  { value: "7.18", label: "7.18" },
  { value: "7.19", label: "7.19" },
  { value: "7.20", label: "7.20" },
  { value: "7.21", label: "7.21" },
  { value: "7.22", label: "7.22" },
  { value: "7.23", label: "7.23" },
  { value: "7.24", label: "7.24" },
  { value: "7.25", label: "7.25" },
  { value: "7.26", label: "7.26" },
  { value: "7.27", label: "7.27" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "9.01", label: "9.01" },
  { value: "9.02", label: "9.02" },
  { value: "9.03", label: "9.03" },
  { value: "9.04", label: "9.04" },
  { value: "9.05", label: "9.05" },
  { value: "9.06", label: "9.06" },
  { value: "9.07", label: "9.07" },
  { value: "9.08", label: "9.08" },
  { value: "9.09", label: "9.09" },
  { value: "9.10", label: "9.10" },
  { value: "9.11", label: "9.11" },
  { value: "9.12", label: "9.12" },
  { value: "9.13", label: "9.13" },
  { value: "9.14", label: "9.14" },
  { value: "9.15", label: "9.15" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
];
